import type { Placement } from '@floating-ui/react-dom';
import React from 'react';
import PopOverArrow from '../components/PopOverArrow';
import PopOverPrimitive from '../components/PopOverPrimitive';
import * as styles from './ControlBarPopOver.module.scss';

const OFFSET = 14;
const SCREEN_PADDING = 12;

interface ControlBarPopOverProps {
  children: React.ReactNode;
  content: React.ReactNode;
  open: boolean;
  placement: Placement;
  onOpenChange: (open: boolean) => void;
  hide?: boolean;
  arrowClassName?: string;
}

const ControlBarPopOver = ({
  content,
  open,
  children,
  placement,
  onOpenChange,
  hide,
  arrowClassName,
}: ControlBarPopOverProps) => {
  return (
    <PopOverPrimitive
      onOpenChange={onOpenChange}
      open={open}
      offset={OFFSET}
      namespace="controlBar"
      screenPadding={SCREEN_PADDING}
      placement={placement}
      trigger="click"
      autoUpdateAnimationFrame
      noFlip
      hideWhenReferenceHidden
    >
      <PopOverPrimitive.Trigger asChild>{children}</PopOverPrimitive.Trigger>

      {!hide && (
        <PopOverPrimitive.Floating className={styles.floatingContainer}>
          <PopOverPrimitive.Content className={styles.inner}>
            {content}
          </PopOverPrimitive.Content>

          <PopOverArrow className={arrowClassName} />
        </PopOverPrimitive.Floating>
      )}
    </PopOverPrimitive>
  );
};

ControlBarPopOver.Anchor = PopOverPrimitive.Anchor;

export default ControlBarPopOver;
